<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-user-view">
		<div class="vx-row">
			<div class="vx-col flex-1" id="account-info-col-1">
				<table>
					<caption></caption>
					<thead>
						<tr>
							<th scope="col"></th>
						</tr>
					</thead>
					<tr>
						<td class="font-semibold">{{ "No" + " " + $t("Optimization.Optimization") }}</td>
						<td>{{ data.id }}</td>
					</tr>
					<tr>
						<td class="font-semibold">{{ $t("Group.Group") }}</td>
						<td>{{ data.added_on }}</td>
					</tr>
				</table>
			</div>

			<div class="vx-col flex-1" id="account-info-col-2">
				<table>
					<caption></caption>
					<thead>
						<tr>
							<th scope="col"></th>
						</tr>
					</thead>
					<tr>
						<td class="font-semibold">{{ $t("Name") }}</td>
						<td>{{ data.name }}</td>
					</tr>
					<tr>
						<td class="font-semibold">{{ $t("RoutingType.RoutingType") }}</td>
						<td>{{ data.routing_api }}</td>
					</tr>
				</table>
			</div>
			<div class="vx-col flex-1" id="account-info-col-3">
				<table>
					<caption></caption>
					<thead>
						<tr>
							<th scope="col"></th>
						</tr>
					</thead>
					<tr>
						<td class="font-semibold">{{ $t("Routing.Table.AddedOn") }}</td>
						<td>{{ data.added_on }}</td>
					</tr>
					<tr>
						<td class="font-semibold">{{ $t("TypeConfig.Form.Status") }}</td>
						<td>{{ data.status }}</td>
					</tr>
				</table>
			</div>
		</div>
		<vs-divider />
		<div class="vx-row">
			<div class="vx-col w-full md:w-1/3">
				<vx-card card-border>
					<div
						class="p-6"
						:class="{
							'flex justify-between flex-row-reverse items-center': iconRight,
							'text-center': !iconRight,
						}"
					>
						<span
							class="p-3 inline-flex rounded-full"
							:class="[`text-${color}`, {'mb-4': !iconRight}]"
							:style="{background: `rgba(var(--vs-${color}),.15)`}"
						>
							<i class="material-icons">group</i>
						</span>
						<div class="truncate">
							<span class="font-semibold">{{ $t("Routing.RouteResult.TotalResources") }}</span>
							<h2 class="mb-1 font-bold">{{ data.total_vehicles }}</h2>
						</div>
					</div>
				</vx-card>
			</div>
			<div class="vx-col w-full md:w-1/3">
				<vx-card card-border>
					<div
						class="p-6"
						:class="{
							'flex justify-between flex-row-reverse items-center': iconRight,
							'text-center': !iconRight,
						}"
					>
						<span
							class="p-3 inline-flex rounded-full"
							:class="[`text-${color}`, {'mb-4': !iconRight}]"
							:style="{background: `rgba(var(--vs-${color}),.15)`}"
						>
							<i class="material-icons">how_to_reg</i>
						</span>
						<div class="truncate">
							<span class="font-semibold">{{ $t("Routing.RouteResult.ResourcesRouted") }}</span>
							<h2 class="mb-1 font-bold">{{ data.total_routed_vehicles }}</h2>
						</div>
					</div>
				</vx-card>
			</div>
			<div class="vx-col w-full md:w-1/3">
				<vx-card card-border>
					<div
						class="p-6"
						:class="{
							'flex justify-between flex-row-reverse items-center': iconRight,
							'text-center': !iconRight,
						}"
					>
						<span
							class="p-3 inline-flex rounded-full"
							:class="[`text-${color}`, {'mb-4': !iconRight}]"
							:style="{background: `rgba(var(--vs-${color}),.15)`}"
						>
							<i class="material-icons">person_add_disabled</i>
						</span>
						<div class="truncate">
							<span class="font-semibold">{{ $t("Routing.RouteResult.ResourcesNotRouted") }}</span>
							<h2 class="mb-1 font-bold">{{ data.total_not_routed_vehicles }}</h2>
						</div>
					</div>
				</vx-card>
			</div>
		</div>
		<div class="vx-row mt-2">
			<div class="vx-col w-full md:w-1/3">
				<vx-card card-border>
					<div
						class="p-6"
						:class="{
							'flex justify-between flex-row-reverse items-center': iconRight,
							'text-center': !iconRight,
						}"
					>
						<span
							class="p-3 inline-flex rounded-full"
							:class="[`text-${color}`, {'mb-4': !iconRight}]"
							:style="{background: `rgba(var(--vs-${color}),.15)`}"
						>
							<i class="material-icons">location_on</i>
						</span>
						<div class="truncate">
							<span class="font-semibold">{{ $t("Routing.RouteResult.TotalVisitPoints") }}</span>
							<h2 class="mb-1 font-bold">{{ data.total_visit_points }}</h2>
						</div>
					</div>
				</vx-card>
			</div>
			<div class="vx-col w-full md:w-1/3">
				<vx-card card-border>
					<div
						class="p-6"
						:class="{
							'flex justify-between flex-row-reverse items-center': iconRight,
							'text-center': !iconRight,
						}"
					>
						<span
							class="p-3 inline-flex rounded-full"
							:class="[`text-${color}`, {'mb-4': !iconRight}]"
							:style="{background: `rgba(var(--vs-${color}),.15)`}"
						>
							<i class="material-icons">where_to_vote</i>
						</span>
						<div class="truncate">
							<span class="font-semibold">{{ $t("Routing.RouteResult.VisitPointsRouted") }}</span>
							<h2 class="mb-1 font-bold">{{ data.total_routed_visit_points }}</h2>
						</div>
					</div>
				</vx-card>
			</div>
			<div class="vx-col w-full md:w-1/3">
				<vx-card card-border>
					<div
						class="p-6"
						:class="{
							'flex justify-between flex-row-reverse items-center': iconRight,
							'text-center': !iconRight,
						}"
					>
						<span
							class="p-3 inline-flex rounded-full"
							:class="[`text-${color}`, {'mb-4': !iconRight}]"
							:style="{background: `rgba(var(--vs-${color}),.15)`}"
						>
							<i class="material-icons">location_off</i>
						</span>
						<div class="truncate">
							<span class="font-semibold">{{ $t("Routing.RouteResult.VisitPointsNotRouted") }}</span>
							<h2 class="mb-1 font-bold">{{ data.total_not_routed_visit_points }}</h2>
						</div>
					</div>
				</vx-card>
			</div>
		</div>
		<div class="vx-row mt-2">
			<div class="vx-col w-full md:w-1/3">
				<vx-card card-border>
					<div
						class="p-6"
						:class="{
							'flex justify-between flex-row-reverse items-center': iconRight,
							'text-center': !iconRight,
						}"
					>
						<span
							class="p-3 inline-flex rounded-full"
							:class="[`text-${color}`, {'mb-4': !iconRight}]"
							:style="{background: `rgba(var(--vs-${color}),.15)`}"
						>
							<i class="material-icons">access_time</i>
						</span>
						<div class="truncate">
							<span class="font-semibold">{{ $t("Routing.RouteResult.RoutesTime") }}</span>
							<h2 class="mb-1 font-bold">{{ data.total_time_all_routes }}</h2>
						</div>
					</div>
				</vx-card>
			</div>
			<div class="vx-col w-full md:w-1/3">
				<vx-card card-border>
					<div
						class="p-6"
						:class="{
							'flex justify-between flex-row-reverse items-center': iconRight,
							'text-center': !iconRight,
						}"
					>
						<span
							class="p-3 inline-flex rounded-full"
							:class="[`text-${color}`, {'mb-4': !iconRight}]"
							:style="{background: `rgba(var(--vs-${color}),.15)`}"
						>
							<i class="material-icons">departure_board</i>
						</span>
						<div class="truncate">
							<span class="font-semibold">{{ this.$t("ResourceModule.Create.MaxServiceTime") }}</span>
							<h2 class="mb-1 font-bold">{{ data.total_minimum_time_service }}</h2>
						</div>
					</div>
				</vx-card>
			</div>
			<div class="vx-col w-full md:w-1/3">
				<vx-card card-border>
					<div
						class="p-6"
						:class="{
							'flex justify-between flex-row-reverse items-center': iconRight,
							'text-center': !iconRight,
						}"
					>
						<span
							class="p-3 inline-flex rounded-full"
							:class="[`text-${color}`, {'mb-4': !iconRight}]"
							:style="{background: `rgba(var(--vs-${color}),.15)`}"
						>
							<i class="material-icons">language</i>
						</span>
						<div class="truncate">
							<span class="font-semibold">{{ $t("Routing.RouteResult.TotalDistance") }}</span>
							<h2 class="mb-1 font-bold">{{ data.total_distance | removeDecimals }}</h2>
						</div>
					</div>
				</vx-card>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		color: {
			type: String,
			default: "primary",
		},
		colorTo: {
			type: String,
		},
		type: {
			type: String,
			default: "line",
		},
		iconRight: {
			type: Boolean,
			default: false,
		},
		data: {
			type: Object,
		},
	},
	filters: {
		removeDecimals(num = 0.03) {
			return num.toFixed(1);
		},
	},
};
</script>

<style lang="scss">
#avatar-col {
	width: 10rem;
}

#page-user-view {
	table {
		td {
			vertical-align: top;
			min-width: 140px;
			padding-bottom: 0.8rem;
			word-break: break-all;
		}

		&:not(.permissions-table) {
			td {
				@media screen and (max-width: 370px) {
					display: block;
				}
			}
		}
	}
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
	only screen and (min-width: 636px) and (max-width: 991px) {
	#account-info-col-1 {
		width: calc(100% - 12rem) !important;
	}
}
</style>
